import type React from 'react';

type StatChipProps = {
  label: string;
};

export const StatChip: React.FC<StatChipProps> = ({ label }) => {
  return (
    <span className='px-3 py-1 bg-white text-gray-400 text-pico rounded-md border border-gray-200'>
      {label}
    </span>
  );
};
